import { defineStore } from 'pinia'
import { request } from '@/utils/request'

/**
 * 供需身份字典项类型定义
 */
export interface SupplyDemandIdentityDict {
  text: string
  shortName: string
  value: number
  desc: string
}

/**
 * 业务全局状态 Store
 */
export const useBusinessGlobalStore = defineStore({
  id: 'business-global',
  state: () => ({
    supplyDemandIdentityDicts: [] as SupplyDemandIdentityDict[]
  }),

  actions: {
    /**
     * 从接口获取供需身份字典
     */
    async fetchSupplyDemandIdentityDicts(): Promise<SupplyDemandIdentityDict[]> {
      try {
        const res = await request.get('/common/supplyDemandIdentity')
        this.supplyDemandIdentityDicts = res.data as SupplyDemandIdentityDict[]
        return this.supplyDemandIdentityDicts
      } catch (e) {
        console.error('获取供需身份字典失败:', e)
        this.supplyDemandIdentityDicts = []
        return []
      }
    }
  }
})
